{
  "SectionheaderDatetime": "Data hora",
  "SectionheaderTimerange": "Período",
  "SectionheaderDaterange": "Intervalo de data\/hora personalizado",
  "SectionheaderDaysoftheweek": "Dias da semana",
  "InputlabelBetween": "Entre:",
  "InputlabelAnd": "E:",
  "RadiolabelRealtime": "Tempo real (agora)",
  "RadiolabelToday": "Hoje",
  "RadiolabelYesterday": "Ontem",
  "RadiolabelThisweek": "Essa semana",
  "RadiolabelLastweek": "Semana Anterior",
  "RadiolabelThismonth": "Este mês",
  "RadiolabelLastmonth": "Mês passado",
  "RadiolabelCustom": "Personalizado...",
  "RadiolabelDays": "Dias:",
  "NAME": "DateTime",
  "SectionHeaderLastXDays": "Últimos \"X\" dias",
  "RadiolabelLastXDays": "Últimos \"X\" dias"
}